import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  createLegalDocument,
  deleteLegalDocument,
} from '@store/LegalDocumentReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'

export const LegalDocumentForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.legalDocument)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createLegalDocument(values)).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteLegalDocument(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

LegalDocumentForm.displayName = 'LegalDocumentForm'

export default LegalDocumentForm
